var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThingsGateways = function SvgThingsGateways(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DEE0",
    d: "M55.426 16v32L27.713 64 0 48V16L27.713 0zM5.328 19.076v25.848l22.385 12.924 22.385-12.924V19.076L27.713 6.152zm13.282 18.26c5.028-5.026 13.179-5.026 18.206 0l-3.767 3.769a7.546 7.546 0 0 0-10.671 0zm-7.231-7.231c9.021-9.021 23.648-9.022 32.669 0l-3.768 3.767c-6.94-6.94-18.194-6.94-25.135 0z"
  })));
};
export { SvgThingsGateways as ReactComponent };
export default __webpack_public_path__ + "79c020550da8115508f381ebc68793db.svg";